import { Component } from '@verndale/core';
import MicroModal from 'micromodal';
import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.id = this.el._$('.modal').id;
    this.videoId = this.el._$('.wistia_embed').id;
    this.videoHash = this.el._$('.wistia_embed').dataset.videoId;
    this.dom = {
      $closeButton: this.el._$('.modal__close'),
      $overlay: this.el._$('.modal__overlay'),
      $modal: this.el._$('.modal__container')
    };
  }

  addListeners() {
    const { $closeButton, $overlay, $modal, $openButton } = this.dom;
    const eles = document.querySelectorAll(`[data-micromodal-trigger="${this.id}"]`);
    document.getElementById(this.videoId).style.display = '';
    window.Wistia.api(this.videoId).replaceWith(this.videoHash);
    eles.forEach(el => {
      el._on('click', this.openModal.bind(this))
    });
    $closeButton._on('click', this.closeModal.bind(this));
    $overlay._on('click', this.closeModal.bind(this));
    $modal._on('click', this.modalClick.bind(this));
  }

  openModal(e) {
    e.preventDefault();
    e.stopPropagation();
    $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
    MicroModal.show(this.id);

    dispatchGenericEvent(constEvent.VIDEO_MODAL_OPENED);
  }

  closeModal(e) {
    e.preventDefault();
    e.stopPropagation();
    MicroModal.close(this.id);
    dispatchGenericEvent(constEvent.VIDEO_MODAL_CLOSED);
  }

  modalClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }
}

export default Module;
